module.exports = __webpack_public_path__ + "img/u2737.672b9ccd.jpg";